import {
  MonthOverviewActionContainer,
  SalaryPageContainer,
} from "../salary.styled";
import { useState } from "react";
import { SalaryList } from "../salaryList.component";
import { WorkerDropdown } from "../workerDropDown.component";
import { CompanyWorker } from "model/Company";

export const MonthOverview = (): JSX.Element => {
  const [selectedWorker, setSelectedWorker] = useState<CompanyWorker>();

  return (
    <SalaryPageContainer>
      <MonthOverviewActionContainer>
        <WorkerDropdown
          selectedWorker={selectedWorker}
          setSelectedWorker={setSelectedWorker}
          onlyActiveWorkers={false}
        />
      </MonthOverviewActionContainer>
      <SalaryList selectedWorker={selectedWorker?.id} />
    </SalaryPageContainer>
  );
};
